import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css';

import de from 'vuetify/lib/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { de },
      current: process.env.VUE_APP_I18N_LOCALE,
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#7FBA28',
                secondary: '#319CD4',
                accent: '#EFA207',
                info: '#595959',
                anchor: '#9B9B9B',
                gray: {
                    darken5: '#282828',
                    base: '#CCCCCC',
                    lighten1: '#EFF1F2',
                    lighten2: '#f3f5f6',
                },
                basic: {
                    base: '#e45e1d',
                    lighten1: '#eb8656',
                    lighten2: '#f2af8e',
                },
                periodic: {
                    base: '#f7a71b',
                    lighten1: '#f9bd54',
                    lighten2: '#fbd38d',
                },
                online: '#7FBA28',
                malachite: '#2ECC71',
            },
        },
    },
    icons: {
        iconfont: 'fa',
    },
});
